import { render, staticRenderFns } from "./ManagerConsults.vue?vue&type=template&id=435a0143&scoped=true&"
import script from "./ManagerConsults.vue?vue&type=script&lang=js&"
export * from "./ManagerConsults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435a0143",
  null
  
)

export default component.exports